module.exports = __webpack_public_path__ + "static/img/laiafi-simione.7419d8e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/laiafi-simione.jpg
// module id = AvpH
// module chunks = 0